import { TextMap } from "../../types";

const zh: TextMap = {
  choose_preferred_wallet: "选择你的钱包",
  connect_mobile_wallet: "连接至移动端钱包",
  scan_qrcode_with_wallet: "使用兼容 WalletConnect 的钱包扫描二维码",
  connect: "连接",
  // TODO: review following translations
  qrcode: "二维码",
  mobile: "移动",
  copy_to_clipboard: "复制到剪贴板",
  copied_to_clipboard: "复制到剪贴板成功！",
  show_more: "显示更多",
  show_less: "显示较少",
};

export default zh;
